import {
    REQUEST_PURCHASE_RETURNS,
    FETCH_PURCHASE_RETURNS_SUCCESS,
    FETCH_PURCHASE_RETURNS_FAILURE,
    SELECT_PURCHASE_RETURN,
    SELECT_VENDOR,
    RESET_CURRENT_PURCHASE_RETURN,
    REQUEST_PURCHASE_RETURN_DETAIL,
    FETCH_PURCHASE_RETURN_DETAIL_SUCCESS,
    FETCH_PURCHASE_RETURN_DETAIL_FAILURE,
    REQUEST_CREATING_PURCHASE_RETURN,
    CREATE_PURCHASE_RETURN_SUCCESS,
    CREATE_PURCHASE_RETURN_FAILURE,
    REQUEST_EDITING_PURCHASE_RETURN,
    EDIT_PURCHASE_RETURN_SUCCESS,
    EDIT_PURCHASE_RETURN_FAILURE,
    COMPLETE_PURCHASE_RETURN,
    COMPLETE_PURCHASE_RETURN_SUCCESS,
    COMPLETE_PURCHASE_RETURN_FAILURE,
    REQUEST_VOID_PURCHASE_RETURN,
    VOID_PURCHASE_RETURN_SUCCESS,
    VOID_PURCHASE_RETURN_FAILURE,
    REQUEST_SYNC_QB_PDF,
    FETCH_SYNC_QB_PDF_SUCCESS,
    FETCH_SYNC_QB_PDF_FAILURE,
} from '../actions/type';

const INITIAL_STATE = {
    all: [],
    currentPurchaseReturn: null,
    currentPurchaseReturnDetail: null,
    currentVendor: null,
    isLoading: true,
    error: null,
    detailIsLoading: false,
    detailError: null,
    purchaseReturnIsCreating: false,
    purchaseReturnCreateError: null,
    purchaseReturnCreated: false,
    purchaseReturnIsEditing: false,
    purchaseReturnEditError: null,
    purchaseReturnEdited: false,
    purchaseReturnIsCompleting: false,
    purchaseReturnCompleteError: null,
    purchaseReturnCompleted: false,
    purchaseReturnIsVoiding: false,
    purchaseReturnVoidError: null,
    purchaseReturnVoided: false,
    syncQbLoading: false,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        // Product action handlers
        case REQUEST_PURCHASE_RETURNS:
            return { ...state, error: null, isLoading: true };
        case FETCH_PURCHASE_RETURNS_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_PURCHASE_RETURNS_FAILURE:
            const error = action.payload.data || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_PURCHASE_RETURN:
            return {...state, currentPurchaseReturn: action.payload };
        // case SELECT_VENDOR:
        //     return {...state, currentVendor: action.payload };
        case RESET_CURRENT_PURCHASE_RETURN:
            return { ...state, currentPurchaseReturn: null, currentPurchaseReturnDetail: null };
        case REQUEST_PURCHASE_RETURN_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_PURCHASE_RETURN_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentPurchaseReturnDetail: action.payload, detailError: null, detailIsLoading: false };
        case FETCH_PURCHASE_RETURN_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        case REQUEST_CREATING_PURCHASE_RETURN:
            return { ...state, purchaseReturnIsCreating: true, purchaseReturnCreateError: null, purchaseReturnCreated: false };
        case CREATE_PURCHASE_RETURN_SUCCESS:
            return { ...state, purchaseReturnIsCreating: false, purchaseReturnCreateError: null, purchaseReturnCreated: true };
        case CREATE_PURCHASE_RETURN_FAILURE:
            const purchaseReturnCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, purchaseReturnIsCreating: false, purchaseReturnCreateError: purchaseReturnCreateError, purchaseReturnCreated: false };
        case REQUEST_EDITING_PURCHASE_RETURN:
            return { ...state, purchaseReturnIsEditing: true, purchaseReturnEditError: null, purchaseReturnEdited: false };
        case EDIT_PURCHASE_RETURN_SUCCESS:
            return { ...state, purchaseReturnIsEditing: false, purchaseReturnEditError: null, purchaseReturnEdited: true };
        case EDIT_PURCHASE_RETURN_FAILURE:
            const purchaseReturnEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, purchaseReturnIsEditing: false, purchaseReturnEditError: purchaseReturnEditError, purchaseReturnEdited: false };
        case COMPLETE_PURCHASE_RETURN:
            return { ...state, purchaseReturnIsCompleting: true, purchaseReturnCompleteError: null, purchaseReturnCompleted: false };
        case COMPLETE_PURCHASE_RETURN_SUCCESS:
            return { ...state, purchaseReturnIsCompleting: false, purchaseReturnCompleteError: null, purchaseReturnCompleted: true };
        case COMPLETE_PURCHASE_RETURN_FAILURE:
            const purchaseReturnCompleteError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, purchaseReturnIsCompleting: false, purchaseReturnCompleteError: purchaseReturnCompleteError, purchaseReturnCompleted: false };
        case REQUEST_SYNC_QB_PDF:
          return { ...state, syncQbLoading: true };
        case FETCH_SYNC_QB_PDF_SUCCESS:
          return { ...state, syncQbLoading: false };
        case FETCH_SYNC_QB_PDF_FAILURE:
          return { ...state, syncQbLoading: false };
        
        case REQUEST_VOID_PURCHASE_RETURN:
          return {
            ...state,
            purchaseReturnIsVoiding: true,
            purchaseReturnVoidError: null,
            purchaseReturnVoided: false,
          };
        case VOID_PURCHASE_RETURN_SUCCESS:
          return {
            ...state,
            purchaseReturnIsVoiding: false,
            purchaseReturnVoidError: null,
            purchaseReturnVoided: true,
          };
        case VOID_PURCHASE_RETURN_FAILURE:
          const purchaseReturnVoidError = action.payload.data || { message: action.payload.message };
          alert(JSON.stringify(purchaseReturnVoidError));
          return {
            ...state,
            purchaseReturnIsVoiding: false,
            purchaseReturnVoidError,
            purchaseReturnVoided: false,
          };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/purchaseReturns_reducer.js